import { AccessRestrictedCard } from '@/components/Cards/AccessRestrictedCard/AccessRestrictedCard';
import { Flex } from '@tremor/react';

const TEXT =
  'Your organization does not have proper subscription tier. Contant your admin or current subscription owner';

export function WrongSubscriptionTier() {
  return (
    <Flex justifyContent="center" alignItems="center" style={{ height: '100%' }}>
      <AccessRestrictedCard message={TEXT} />
    </Flex>
  );
}
